import { defineMessages } from 'react-intl';

export default defineMessages({
    readMore: {
        id: 'common.controllers.MLModifierDirectiveCtrl.Read more',
        defaultMessage: ' <a>Read more</a>'
    },
    qualifyForDiscountBasedOnSystemAge: {
        id: 'common.controllers.MLModifierDirectiveCtrl.You may qualify for a discount based on the age of the following systems',
        defaultMessage: 'You may qualify for a discount based on the age of the following systems:'
    },
    dateFormatMessage:{
        id:'common.controllers.MLModifierDirectiveCtrl.Enter date of format MM/YYYY',
        defaultMessage:'Enter date of format MM/YYYY'
    },
    invalidMonth:{
        id:'common.controllers.MLModifierDirectiveCtrl.Please enter a month from 1 to 12',
        defaultMessage:'Please enter a month from 1 to 12'
    },
    invalidYear:{
        id:'common.controllers.MLModifierDirectiveCtrl.Please enter year that is within 3 years of current year',
        defaultMessage:'Please enter year that is within 3 years of current year'
    },
    yearPlaceHolder:{
        id: 'ml.endorsement.pa.directives.templates.Date Format',
        defaultMessage:'MM/YYYY'
    },
    anotherProductToolTipContentQB:{
        id: 'ml.endorsement.pa.directives.templates.A discount may apply',
        defaultMessage:'A discount may apply if insured as an active life insurance policy from Farmers Life Insurance or an affiliated company.'
    },
    electricYearToolTipContentQB:{
        id: 'ml.endorsement.pa.directives.Electrical system',
        defaultMessage:'Electrical system is considered updated if it has been updated to circuit breaker panel(s) within the past 30 years, and has at least 100 amp service. Proof of updates is required.'
    },
    policyNumberTooltipContent:{
        id: 'ml.endorsement.pa.directives.policyNumberTooltipContent',
        defaultMessage:"Enter the policy number if available. This optional field appears because no matching policies were found during a system search. Adding a number helps us tag the related line of business for the Multi- Policy Discount"
    },
    signalNotification: {
         id: 'common.controllers.MLModifierDirectiveCtrl.signal',
        defaultMessage: 'A 10% initial discount is applied when a driver is enrolled at new business. <strong>Select "Yes" to unlock additional savings.</strong>'
        
    },
    invalidFutureDate:{
        id:'common.controllers.MLModifierDirectiveCtrl.The date entered cannot be in the future. Please select a valid date.',
        defaultMessage:'The date entered cannot be in the future. Please select a valid date.'
    },
    labelForSmokeFire: {
        id: 'common.controllers.MLModifierDirectiveCtrl.Label for Smoke and Fire',
        defaultMessage: 'Does the home have a smoke detector or fire monitoring system?'
    }
    
});
